import sentry from '@/3rd-parties/sentry'
import EventBus from '@/eventBus'

import QuizStatuses from '@/constants/QuizStatuses'
import store from '@/store'

const MESSAGE_TYPES = {
  ANSWER_QUIZ: 'answer-quiz',
  QUIZ_AUDIENCE: 'quiz-audience',
  AUDIENCE_ONLINE: 'audience-online',
}

async function handleWaitResNextSlide({ slide, editor, doc }) {
  const dataSocket = doc.data
  // Đợi đến khi nào res của nextSlide (hàm confirmNextSlide()) trả về thì mới startQuiz
  const self = editor
  if (self.$store.state.isLoadNextSlide[dataSocket.slideId]) {
    // eslint-disable-next-line promise/avoid-new
    await new Promise((resolve) => {
      let timeInterval = null
      timeInterval = setInterval(() => {
        if (!self.$store.state.isLoadNextSlide[dataSocket.slideId]) {
          clearInterval(timeInterval)
          resolve()
        }
      }, 100)
    })
    slide = editor.$store.getters.activeActivity
    if (slide.id !== dataSocket.slideId) {
      return false
    }
  }
  return {
    isGetDataSlideSlowThanSocket: true,
    slide,
    dataSocket,
  }
}

function handleQuizAnswerMessage(doc, rootComponent) {
  if (rootComponent.$store.getters.activeActivity.id == doc.data.id) {
    EventBus.$emit('answer-quiz', doc.data)
  }
}

async function handleStartCountdownPickAnswer(doc, slide, rootComponent) {
  let isGetDataSlideSlowThanSocket = false
  if ((!slide || !slide.id) && doc.data.slideId) {
    const result = await handleWaitResNextSlide({
      slide,
      editor: rootComponent,
      doc,
    })
    if (!result) {
      return
    }
    isGetDataSlideSlowThanSocket = result.isGetDataSlideSlowThanSocket
    slide = result.slide
    doc.data = result.dataSocket
  }

  if (slide.type === 'pickAnswer') {
    if (doc.data.quizTimestamp) {
      rootComponent.$store.getters.activeActivity.quizTimestamp = doc.data.quizTimestamp
      rootComponent.$store.state.startCountdownPickAnswer = doc.data.quizTimestamp
    }

    rootComponent.$store.state.countdownTimeToAnswer = slide.timeToAnswer
    rootComponent.$store.getters.activeActivity.quizToken = doc.data.quizToken
    rootComponent.$store.getters.activeActivity.quizStatus = QuizStatuses.QUESTION_SCREEN
    rootComponent.$store.getters.activeActivity.numberOfHintsShown = doc.data.numberOfHintsShown
    rootComponent.$store.dispatch('updateSlide', rootComponent.$store.getters.activeActivity)
    EventBus.$emit('start-countdown-pick-answer', slide.id)
    if (isGetDataSlideSlowThanSocket) {
      EventBus.$emit('recheck-progress-bar', slide.id)
    }
  }
}

async function handleQuizAudience(doc, rootComponent) {
  if (rootComponent.$store.state.presentation.audiencePacing) return
  const slide = rootComponent.$store.getters.activeActivity
  sentry.addBreadcrumb({
    level: 'info',
    message: 'Socket message with type "quiz-audience"',
    data: {
      data: doc.data,
      quizTimestamp: doc.data.quizTimestamp,
    },
  })

  if (doc.action === 'startCountdownPickAnswer') {
    handleStartCountdownPickAnswer(doc, slide, rootComponent)
  }
}

function handleAudienceOnline(doc, rootComponent) {
  if (rootComponent.$store.state.audienceName) {
    const data = {
      a: rootComponent.audienceId,
      c: rootComponent.$store.state.presentation.uniqueAccessCode,
    }
    if (rootComponent.$store.getters.activeActivity.type === 'pickAnswer' || rootComponent.$store.getters.activeActivity.type === 'spinnerWheel' || rootComponent.$store.getters.activeActivity.type === 'qrcode') {
      data.n = rootComponent.$store.state.audienceName
      data.e = rootComponent.$store.state.audienceEmoji
      data.t = rootComponent.$store.state.audienceQuizTeam
    }
    // eslint-disable-next-line promise/catch-or-return
    store.dispatch('audienceJoinPresentationAction', data)
    store.dispatch('audienceCountJoinPresentationAction')
  }
}

const QuizWebSocketSubscriber = {
  [MESSAGE_TYPES.ANSWER_QUIZ]: handleQuizAnswerMessage,
  [MESSAGE_TYPES.QUIZ_AUDIENCE]: handleQuizAudience,
  [MESSAGE_TYPES.AUDIENCE_ONLINE]: handleAudienceOnline,
}

export default QuizWebSocketSubscriber
